import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Neem Contact Met Ons Op
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Wij staan klaar om u te helpen met al uw CRM vragen. Plan een gratis kennismakingsgesprek 
              of neem direct contact op.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                      <Phone className="w-8 h-8 text-blue-700" />
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Telefoon</h3>
                  <a href="tel:0638823471" className="text-blue-700 hover:text-blue-800 transition-colors duration-200">
                    06 3882 3471
                  </a>
                </CardContent>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                      <Mail className="w-8 h-8 text-blue-700" />
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Email</h3>
                  <a href="mailto:aanvragen@crm-systemen.nl" className="text-blue-700 hover:text-blue-800 transition-colors duration-200 break-all">
                    aanvragen@crm-systemen.nl
                  </a>
                </CardContent>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                      <MapPin className="w-8 h-8 text-blue-700" />
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Adres</h3>
                  <p className="text-gray-600">
                    Javalaan 7<br />
                    3742 CN Baarn<br />
                    Nederland
                  </p>
                </CardContent>
              </Card>

              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
                      <Clock className="w-8 h-8 text-blue-700" />
                    </div>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">Openingstijden</h3>
                  <p className="text-gray-600">
                    Ma - Vr: 09:00 - 18:00<br />
                    Weekend: Op afspraak
                  </p>
                </CardContent>
              </Card>
            </div>

            {/* Contact Form Placeholder */}
            <Card className="border-2 border-blue-200 shadow-xl">
              <CardContent className="p-8 md:p-12">
                <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                  Plan een Gratis Kennismakingsgesprek
                </h2>
                <p className="text-lg text-gray-600 mb-8 text-center">
                  Het contactformulier wordt binnenkort geactiveerd en gekoppeld aan ons CRM systeem. 
                  Neem nu contact op via telefoon of email.
                </p>

                <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-8 text-center">
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    Liever Direct Contact?
                  </h3>
                  <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <a 
                      href="tel:0638823471"
                      className="inline-flex items-center justify-center px-6 py-3 bg-blue-700 hover:bg-blue-800 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                    >
                      <Phone className="mr-2 w-5 h-5" />
                      Bel: 06 3882 3471
                    </a>
                    <a 
                      href="mailto:aanvragen@crm-systemen.nl"
                      className="inline-flex items-center justify-center px-6 py-3 border-2 border-blue-700 text-blue-700 hover:bg-blue-50 font-semibold rounded-lg transition-all duration-300"
                    >
                      <Mail className="mr-2 w-5 h-5" />
                      Stuur een Email
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Additional Info */}
            <div className="mt-16 text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Wat Kunt U Verwachten?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
                <div>
                  <div className="text-4xl font-bold text-blue-700 mb-2">1</div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Gratis Intakegesprek</h4>
                  <p className="text-gray-600">
                    Wij luisteren naar uw uitdaging en geven een eerste advies.
                  </p>
                </div>
                <div>
                  <div className="text-4xl font-bold text-blue-700 mb-2">2</div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Op Maat Offerte</h4>
                  <p className="text-gray-600">
                    U ontvangt een heldere offerte zonder verrassingen.
                  </p>
                </div>
                <div>
                  <div className="text-4xl font-bold text-blue-700 mb-2">3</div>
                  <h4 className="text-lg font-semibold text-gray-900 mb-2">Snelle Start</h4>
                  <p className="text-gray-600">
                    Bij akkoord kunnen wij vaak binnen een week starten.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
